import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    // Safari does not focus clicked buttons; establish where closing returns focus.
    event.currentTarget.focus()
    this.dialogTarget.showModal()
    this.dialogTarget.querySelector("[autofocus]").focus()
  }
}
